function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { AuthProviders } from '@/types/server';
import twitchModNightbotDark from '@/assets/nightbot/TwitchModNightbotDark.png';
import twitchModNightbotLight from '@/assets/nightbot/TwitchModNightbotLight.png';
import youtubeModNightbotDark from '@/assets/nightbot/YoutubeModNightbotDark.png';
import youtubeModNightbotLight from '@/assets/nightbot/YoutubeModNightbotLight.png';
import trovoModNightbot from '@/assets/nightbot/TrovoModNightbot.png';
import noiceModNightbot from '@/assets/nightbot/NoiceModNightbot.png';
import { Box, Code, Image, Link, List, ListItem, Text, useColorModeValue } from '@chakra-ui/react';
import { ExternalUrls } from '@/utils/constants';
import { FormattedMessage, useIntl } from 'react-intl';
import CopyTextButton from './CopyTextButton';
function TwitchOnboardingSteps(param) {
    var channel = param.channel;
    var intl = useIntl();
    var imageSrc = useColorModeValue(twitchModNightbotLight, twitchModNightbotDark);
    if ((channel === null || channel === void 0 ? void 0 : channel.provider) !== AuthProviders.TWITCH) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Text, {
                color: "textSecondary",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "rsS/s7",
                    defaultMessage: "Ensure that you have modded Nightbot in your channel. If Nightbot is not a moderator, it cannot function properly."
                })
            }),
            /*#__PURE__*/ _jsxs(List, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ _jsx(ListItem, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "VRTFhY",
                            defaultMessage: "1. Go to your <link>chat</link>.",
                            values: {
                                link: function(text) {
                                    return /*#__PURE__*/ _jsx(Link, {
                                        href: ExternalUrls.TWITCH_CHAT(channel.name),
                                        isExternal: true,
                                        children: text
                                    });
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(ListItem, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "HofStz",
                            defaultMessage: "2. Type <code>/mod nightbot</code> into your chat.",
                            values: {
                                code: function(text) {
                                    return /*#__PURE__*/ _jsx(Code, {
                                        children: text
                                    });
                                }
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Box, {
                borderRadius: "lg",
                borderWidth: 1,
                borderColor: "borderSecondary",
                overflow: "hidden",
                children: /*#__PURE__*/ _jsx(Image, {
                    src: imageSrc,
                    alt: intl.formatMessage({
                        id: "X18/jH",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Twitch Mod Nightbot"
                            }
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(List, {
                spacing: 1,
                children: /*#__PURE__*/ _jsx(ListItem, {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "TUgr3N",
                        defaultMessage: "3. If done successfully, you may close this window."
                    })
                })
            })
        ]
    });
}
function YoutubeOnboardingSteps() {
    var intl = useIntl();
    var imageSrc = useColorModeValue(youtubeModNightbotLight, youtubeModNightbotDark);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Text, {
                color: "textSecondary",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "rsS/s7",
                    defaultMessage: "Ensure that you have modded Nightbot in your channel. If Nightbot is not a moderator, it cannot function properly."
                })
            }),
            /*#__PURE__*/ _jsx(Text, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "ZDNEwZ",
                    defaultMessage: "1. Go to your YouTube <link>Community Settings</link>.",
                    values: {
                        link: function(text) {
                            return /*#__PURE__*/ _jsx(Link, {
                                href: ExternalUrls.YOUTUBE_COMMUNITY_SETTINGS,
                                isExternal: true,
                                children: text
                            });
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsx(CopyTextButton, {
                text: ExternalUrls.YOUTUBE_NIGHTBOT_CHANNEL
            }),
            /*#__PURE__*/ _jsx(Text, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "gZxLLm",
                    defaultMessage: "2. Copy the URL above, and paste into managing moderators."
                })
            }),
            /*#__PURE__*/ _jsx(Box, {
                borderRadius: "lg",
                borderWidth: 1,
                borderColor: "borderSecondary",
                overflow: "hidden",
                children: /*#__PURE__*/ _jsx(Image, {
                    src: imageSrc,
                    alt: intl.formatMessage({
                        id: "Am2RRF",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Youtube Mod Nightbot"
                            }
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(List, {
                children: [
                    /*#__PURE__*/ _jsx(ListItem, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "gotaZM",
                            defaultMessage: "3. Remember to click <b>Save</b>!",
                            values: {
                                b: function(text) {
                                    return /*#__PURE__*/ _jsx("b", {
                                        children: text
                                    }, "bold");
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(ListItem, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "PIhd33",
                            defaultMessage: "4. Go <b>Live</b>, as Nightbot will only join active streams on Youtube.",
                            values: {
                                b: function(text) {
                                    return /*#__PURE__*/ _jsx("b", {
                                        children: text
                                    }, "bold");
                                }
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Text, {
                color: "textSecondary",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "CDnaZB",
                    defaultMessage: "Nightbot may take up to 5 minutes to join your channel. And will not connect if the stream is unlisted or private."
                })
            })
        ]
    });
}
function TrovoOnboardingSteps() {
    var intl = useIntl();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Text, {
                color: "textSecondary",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "rsS/s7",
                    defaultMessage: "Ensure that you have modded Nightbot in your channel. If Nightbot is not a moderator, it cannot function properly."
                })
            }),
            /*#__PURE__*/ _jsxs(List, {
                children: [
                    /*#__PURE__*/ _jsx(ListItem, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "HxysGX",
                            defaultMessage: "1. Go to your <link>Roles Manager</link>.",
                            values: {
                                link: function(text) {
                                    return /*#__PURE__*/ _jsx(Link, {
                                        href: ExternalUrls.TROVO_STUDIO_ROLES_MANAGE,
                                        isExternal: true,
                                        children: text
                                    }, "trovoStudioRolesManageLink");
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(ListItem, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "LSISVE",
                            defaultMessage: "2. Search and add <code>Nightbot</code> to the moderator role.",
                            values: {
                                code: function(text) {
                                    return /*#__PURE__*/ _jsx(Code, {
                                        children: text
                                    }, "code");
                                }
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Box, {
                borderRadius: "lg",
                borderWidth: 1,
                borderColor: "borderSecondary",
                overflow: "hidden",
                children: /*#__PURE__*/ _jsx(Image, {
                    src: trovoModNightbot,
                    alt: intl.formatMessage({
                        id: "CsGtXl",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Trovo Mod Nightbot"
                            }
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(List, {
                children: [
                    /*#__PURE__*/ _jsx(ListItem, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "zPM3HY",
                            defaultMessage: "3. Click <b>Save</b> to apply the changes.",
                            values: {
                                b: function(text) {
                                    return /*#__PURE__*/ _jsx("b", {
                                        children: text
                                    }, "bold");
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(ListItem, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "MruNdz",
                            defaultMessage: "4. If done successfully, you may close this window."
                        })
                    })
                ]
            })
        ]
    });
}
function NoiceOnboardingSteps() {
    var intl = useIntl();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Text, {
                color: "textSecondary",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "rsS/s7",
                    defaultMessage: "Ensure that you have modded Nightbot in your channel. If Nightbot is not a moderator, it cannot function properly."
                })
            }),
            /*#__PURE__*/ _jsxs(List, {
                children: [
                    /*#__PURE__*/ _jsx(ListItem, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "hCTlla",
                            defaultMessage: "1. Go to your <link>Noice Studio</link>.",
                            values: {
                                link: function(text) {
                                    return /*#__PURE__*/ _jsx(Link, {
                                        href: ExternalUrls.NOICE_STUDIO,
                                        isExternal: true,
                                        children: text
                                    }, "noiceStudioLink");
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(ListItem, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "oqeskZ",
                            defaultMessage: "2. Click on <b>Settings</b> and then <b>Moderation</b>.",
                            values: {
                                b: function(text) {
                                    return /*#__PURE__*/ _jsx("b", {
                                        children: text
                                    }, "bold");
                                }
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Box, {
                borderRadius: "lg",
                borderWidth: 1,
                borderColor: "borderSecondary",
                overflow: "hidden",
                children: /*#__PURE__*/ _jsx(Image, {
                    src: noiceModNightbot,
                    alt: intl.formatMessage({
                        id: "CEPCUQ",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Noice Mod Nightbot"
                            }
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(List, {
                children: [
                    /*#__PURE__*/ _jsx(ListItem, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "0kSdCK",
                            defaultMessage: "3. Search and add <code>Nightbot</code> to the moderator list.",
                            values: {
                                code: function(text) {
                                    return /*#__PURE__*/ _jsx(Code, {
                                        children: text
                                    }, "code");
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(ListItem, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "MruNdz",
                            defaultMessage: "4. If done successfully, you may close this window."
                        })
                    })
                ]
            })
        ]
    });
}
var _obj;
var AuthProviderBySteps = (_obj = {}, _define_property(_obj, AuthProviders.TWITCH, TwitchOnboardingSteps), _define_property(_obj, AuthProviders.TROVO, TrovoOnboardingSteps), _define_property(_obj, AuthProviders.NOICE, NoiceOnboardingSteps), _define_property(_obj, AuthProviders.YOUTUBE, YoutubeOnboardingSteps), _obj);
export default function AuthProviderSteps(param) {
    var channel = param.channel;
    var _channel_provider;
    var AuthProviderSteps = AuthProviderBySteps[(_channel_provider = channel === null || channel === void 0 ? void 0 : channel.provider) !== null && _channel_provider !== void 0 ? _channel_provider : AuthProviders.TWITCH];
    return AuthProviderSteps != null ? /*#__PURE__*/ _jsx(AuthProviderSteps, {
        channel: channel
    }) : null;
}
